import React, { useEffect, useState } from "react";
import { message, theme } from "antd";
import { Outlet, useNavigate, useLocation } from "react-router";
import { matchRoutes } from "react-router-dom";
import "./MasterLayout.scss";
import OverhypedAI from "@overhyped-ai/connect/OverhypedAI";
import PrimaryNav from "../PrimaryNav";
import { useRecoilState } from "recoil";
import {
uploadInfo,
userInfo,
workspaceReports,
} from "app/config/States/users";
import {
API_ENDPOINT_GET_GST_STATUS,
API_ENDPOINT_GET_TABLE_SCHEMA,
API_ENDPOINT_GET_USER_INFO,
API_ENDPOINT_GET_WORKSPACE_REPORTS,
} from "app/scenes/Auth/auth.constants";
import { apiGet } from "app/services/apiServices";
import Loader from "../Loader";
import AppLoader from "../AppLoader";
import { tableSchema } from "app/config/States/agtable";
import GlobalUploader from "../GlobalUploader";
import { Mixpanel } from "app/config/Mixpanel";
import { getSubdomain } from "app/utils/generic.helper";
import {
agTableAirlineType,
agTableAirlineData,
hotelActiveTabAtom,
agTableHotelData,
agTableHotelType,
} from "app/config/States/agtable"; //my_code
import { apiPost } from "app/services/apiServices"; //my_code
import { tableLoadingState } from "app/config/States/agtable";
import { API_ENDPOINT_MASTERLAYOUT_CLIENT_SERVER,API_ENDPOINT_MASTERLAYOUT_CLIENT_SERVER_New,API_ENDPOINT_SCHEMA_LIST_NEW } from "../../scenes/Flights/flight.constant";
import { tabViewStates,activeTabAtom } from "app/config/States/users"
import { useRecoilValue } from 'recoil';
import OnboardingTasks from "../OnboardingTasks";
import RouteMap from "app/config/routeConfig";




const extractAllRoutePaths = (routes: any[], basePath: string = ""): string[] => {
const paths: string[] = [];
 routes.forEach((route: any) => {
  if (route.path) {
    let fullPath = route.path;
    if (basePath && !route.path.startsWith("/")) {
      fullPath = `${basePath}/${route.path}`;
    } else if (basePath && route.path.startsWith("/")) {
      fullPath = route.path;
    }
  
    fullPath = fullPath === "/" ? "/" : fullPath.replace(/\/$/, "");
  
    if (fullPath && fullPath !== "*" && fullPath !== "") {
      paths.push(fullPath);
    }
    if (route.children && Array.isArray(route.children)) {
      const childPaths = extractAllRoutePaths(route.children, fullPath);
      paths.push(...childPaths);
    }
  }
});
 return paths;
};




const isValidRoute = (pathname: string, routes: any[]): boolean => {
if (pathname === "" || pathname === "/") {
  return true; 
}
try {
  const matches = matchRoutes(routes, pathname);
  if (matches && matches.length > 0) {
    const lastMatch = matches[matches.length - 1];
    return lastMatch.route.path !== "*";
  }
} catch (error) {
}
const allPaths = extractAllRoutePaths(routes);
if (allPaths.includes(pathname)) {
  return true;
}
return allPaths.some((path) => {
  if (pathname === path) return true;
  if (pathname.startsWith(path + "/")) return true;
  const routePattern = path.replace(/:[^/]+/g, "[^/]+");
  const regex = new RegExp(`^${routePattern}(/.*)?$`);
  return regex.test(pathname);
});
};




const MasterLayout = (props: any) => {
const [expandedLayout, setExpandedLayout] = useState(true);
const [isLoading, setLoading] = useState(true);
const [userDetails, setUserDetails] = useRecoilState<any>(userInfo);
const [tableSchemaInfo, setTableSchema] = useRecoilState<any>(tableSchema);
const [uploaderInfo, setUploadInfo] = useRecoilState<any>(uploadInfo);
const [reports, setWorkspaceReports] = useRecoilState(workspaceReports);




const [messageApi, contextHolder] = message.useMessage();
const [airlineType, setAirlineType] = useRecoilState(agTableAirlineType);
const [airlineData, setAirlineData] = useRecoilState(agTableAirlineData);
const [hotelData, setHotelData] = useRecoilState(agTableHotelData);
const [hotelType, setHotelType] = useRecoilState(agTableHotelType);
const [tableLoading, setTableLoading] = useRecoilState(tableLoadingState);
const domain = getSubdomain();
const airlineActiveTab = useRecoilValue(activeTabAtom);
const hotelActiveTab = useRecoilValue(hotelActiveTabAtom);
const [dataLoadingMode, setDataLoadingMode] = useState<Record<string, 'client' | 'server'>>({});




// Determine which activeTab to use based on current route
const currentPath = window.location.pathname;
const isHotelRoute = currentPath.includes('/hotel') || currentPath.includes('/hotels');
const activeTab = isHotelRoute ? hotelActiveTab : airlineActiveTab;








const fetchDocumentSize = async () => {
  setTableLoading(true);
  try {
    const hasAdminWorkspace = userDetails.currentWorkspace?.meta?.full_access;
    // const hasAdminWorkspace = userDetails;




    let tableName: string | null = null;
    let moduleId: string | null = null;
  
    if (tableSchemaInfo && Array.isArray(tableSchemaInfo)) {
      let schema = null;
      schema = tableSchemaInfo.find((item: any) => item.moduleId === activeTab);
    
      // If not found and activeTab contains underscore, try parsing it
      if (!schema && activeTab.includes('_')) {
        const parts = activeTab.split('_');
        const parsedModuleId = parts.slice(0, -1).join('_');
        const index = parseInt(parts[parts.length - 1]);
        const matchingSchemas = tableSchemaInfo.filter((item: any) => item.moduleId === parsedModuleId);
        if (matchingSchemas.length > 0) {
          schema = matchingSchemas[index] || matchingSchemas[0];
        }
      }
      if (!schema) {
        schema = tableSchemaInfo.find((item: any) => item.table_name === activeTab);;
      }
      if (!schema && /^\d+$/.test(activeTab)) {
        let filteredSchemas = tableSchemaInfo.filter((item: any) => item.reportType === "HOTEL");
        if (filteredSchemas.length === 0) {
          filteredSchemas = tableSchemaInfo.filter((item: any) => item.reportType === "AIRLINE");
        }
      
        const index = parseInt(activeTab);
        if (filteredSchemas.length > 0) {
          schema = filteredSchemas[index] || filteredSchemas[0];
        }
      }
      if (schema) {
        tableName = schema.table_name;
        moduleId = schema.moduleId;
      }
    }
  
  
    const payload = hasAdminWorkspace
    ? {
        hasAdminWorkspace: true,
        userDetails: userDetails.currentWorkspace,
        activeTab: activeTab,
        tableName: tableName,
        moduleId: moduleId,
      }
    : {
        useWorkspace: true,
        hasAdminWorkspace: false,
        userDetails: userDetails.currentWorkspace,
        activeTab: activeTab,
        tableName: tableName,
        moduleId: moduleId
      };
    const response = await apiPost(
      API_ENDPOINT_MASTERLAYOUT_CLIENT_SERVER_New,
      // hasAdminWorkspace ? {}: payload
      payload
    );
    if (response.data && response.data.totalCount !== undefined) {
      const totalCount = response.data.totalCount;
      const rows = response.data.rows;
      const limitedRows = rows.slice(0, 500);
      // Get reportType from schema since API doesn't provide it
      let reportType = null;
      if (tableSchemaInfo && Array.isArray(tableSchemaInfo)) {
        const schema = tableSchemaInfo.find((item: any) => item.moduleId === moduleId);
        reportType = schema?.reportType;
      }
      if (reportType === "HOTEL") {
        setHotelData((prevData: any) => ({
          ...prevData,
          [activeTab]: limitedRows
        }));
      } else if (reportType === "AIRLINE") {
        setAirlineType("CLIENT");
        setAirlineData((prevData: any) => ({
          ...prevData,
          [activeTab]: limitedRows
        }));
      } else {
        setAirlineType("CLIENT");
        setAirlineData((prevData: any) => ({
          ...prevData,
          [activeTab]: limitedRows
        }));
      }
    } else {
      // message.error("Invalid response structure");
    }
  } catch (error) {
    message.error("Failed to fetch document size.");
  } finally {
    setTableLoading(false);
  }
};




const [isFetching, setIsFetching] = useState<Record<string, boolean>>({});




const preLoadAllTabsData = async () => {
  if (!tableSchemaInfo || !Array.isArray(tableSchemaInfo) || isFetching['preload']) {
    return;
  }
   setIsFetching(prev => ({ ...prev, preload: true }));
   try {
    // Process both AIRLINE and HOTEL schemas
    const allModules = tableSchemaInfo.filter(
      (schema: any) => schema.reportType === "AIRLINE" || schema.reportType === "HOTEL"
    );
    for (const schema of allModules) {
      const tabId = schema.tableName && schema.tableName.trim() !== ''
        ? schema.tableName
        : `${schema.moduleId}_${allModules.indexOf(schema)}`;
      if (!(airlineData as Record<string, any[]>)[tabId] &&
          !(hotelData as Record<string, any[]>)[tabId] &&
          !isFetching[tabId]) {
        await fetchDocumentSizeForTab(tabId, schema.moduleId, schema.table_name);
      }
    }
  } finally {
    setIsFetching(prev => ({ ...prev, preload: false }));
    setTableLoading(false);
  }
};




// Modified fetchDocumentSize to work for specific tabs with moduleId
const fetchDocumentSizeForTab = async (tabId: string, moduleId: string, tableName: string) => {
  try {
  
    const hasAdminWorkspace = userDetails.currentWorkspace?.meta?.full_access;
    const payload = hasAdminWorkspace
      ? {
          hasAdminWorkspace: true,
          userDetails: userDetails.currentWorkspace,
          activeTab: tabId,
          moduleId: moduleId,
          tableName: tableName
        }
      : {
          useWorkspace: true,
          hasAdminWorkspace: false,
          userDetails: userDetails.currentWorkspace,
          activeTab: tabId,
          moduleId: moduleId,
          tableName: tableName
        };
    const response = await apiPost(
      API_ENDPOINT_MASTERLAYOUT_CLIENT_SERVER_New,
      payload
    );
    if (response.data && response.data.totalCount !== undefined) {
      const rows = response.data.rows;
      const limitedRows = rows.slice(0, 500);
      // Get reportType from schema since API doesn't provide it
      let reportType = null;
      if (tableSchemaInfo && Array.isArray(tableSchemaInfo)) {
        const schema = tableSchemaInfo.find((item: any) => item.moduleId === moduleId);
        reportType = schema?.reportType;
      }
    
      if (reportType === "HOTEL") {
        setHotelData((prevData: any) => ({
          ...prevData,
          [tabId]: limitedRows
        }));
      } else if (reportType === "AIRLINE") {
        setAirlineData((prevData: any) => ({
          ...prevData,
          [tabId]: limitedRows
        }));
      } else {
        setAirlineData((prevData: any) => ({
          ...prevData,
          [tabId]: limitedRows
        }));
      }
    }
  } catch (error) {
  }
};




useEffect(() => {
  if (userDetails.currentWorkspace) {
    preLoadAllTabsData();
  }
}, [userDetails.currentWorkspace, tableSchemaInfo]);




useEffect(() => {
  if (userDetails.currentWorkspace && activeTab) {
    // Check if data already exists in either hotelData or airlineData
    const hasHotelData = (hotelData as Record<string, any[]>)[activeTab];
    const hasAirlineData = (airlineData as Record<string, any[]>)[activeTab];
  
    if (!hasHotelData && !hasAirlineData) {
      fetchDocumentSize();
    } else {
      setTableLoading(false);
    }
  }
}, [activeTab]);




const navigate = useNavigate();
const location = useLocation();








// const fetchAllTableSchema = async () => {
 //   const payload = {
//     domain: domain, // 👈 comes from your app state/prop
//     workspaceId: userDetails.currentWorkspace?.id, // 👈 from userDetails
//   };
 //   try {
//     const response = await apiPost(
//       API_ENDPOINT_SCHEMA_LIST_NEW,
//       payload
//     );
 //     if (response.status) {
//       setTableSchema(response.data);
//     }
//   } catch (err) {
//   }
// };




const fetchAllTableSchema = async () => {
const payload = {
  domain: domain, // comes from your app state/prop
  workspaceId: userDetails.currentWorkspace?.id, // from userDetails
};
try {
  // const response = await apiPost(API_ENDPOINT_SCHEMA_LIST_NEW, payload);
   const response = await apiPost("https://stage-apiplatform.finkraftai.com/api/agtable/schemas/listNew", payload);
  //const response = await apiPost("http://localhost:7002/api/agtable/schemas/listNew", payload);


  if (response.status) {
    let filteredData = response.data;
    const email = (userDetails?.email || "").toLowerCase();
    if (!(email.includes("finkraft.ai") || email.includes("kgrp.in"))) {
      filteredData = filteredData.filter(
        (item: any) => item.activeStatus !== "Inactive"
      );
    }
    setTableSchema(filteredData);
  }
} catch (err) {
}
};








const fetchReportsAndDashboards = async () => {
  const response = await apiGet(API_ENDPOINT_GET_WORKSPACE_REPORTS);
  if (response.status) {
    setWorkspaceReports(response.data);
  }
};




useEffect(() => {
  fetchUserInfo();
  fetchReportsAndDashboards();
  // fetchAllTableSchema();
}, []);
useEffect(() => {
  if (userDetails.currentWorkspace) {
    fetchAllTableSchema();
  }
}, [userDetails.currentWorkspace]);
 const fetchWorkspaceGstinStatus = async () => {
  const response = await apiGet(API_ENDPOINT_GET_GST_STATUS);
  if (response.status) {
    return response.data;
  }
  return null;
};




const fetchUserInfo = async () => {
  setLoading(true);
  const response = await apiGet(API_ENDPOINT_GET_USER_INFO);
  if (response.status) {
    if (!response.data) {
      localStorage.clear();
      navigate("/auth/signin");
    }




    if (response.data?.workspaces.length === 0) {
      localStorage.clear();
      message.error("You do not have any acccess to this portal");
      navigate("/auth/signin");




      return;
    }


    // Check localStorage for previously selected workspace
    const savedWorkspaceId = localStorage.getItem("currentWorkspace");
    let selectedWorkspace = null;


    if (savedWorkspaceId) {
      selectedWorkspace = (response.data.workspaces || []).find(
        (item: any) => item.id === savedWorkspaceId
      );
    }

    if (!selectedWorkspace) {
      let mmtWorkspace = (response.data.workspaces || []).find(
        (item: any) => item?.meta && item?.meta.full_access
      );
      selectedWorkspace = mmtWorkspace
        ? mmtWorkspace
        : response.data.workspaces[0];
    }


    const userWorkspaceGstinStatus = await fetchWorkspaceGstinStatus();

    setUserDetails({
      ...response.data,
      currentWorkspace: selectedWorkspace,
      clusterId: response.data.cluster_id,
      gstinStatus: userWorkspaceGstinStatus,
    });




    localStorage.setItem(
      "currentWorkspace",
      selectedWorkspace?.id
    );




    Mixpanel.identify(response.data.id);
    Mixpanel.track("Successful login", {
      domain: response?.data?.email?.split("@")[1],
    });
    //@ts-ignore
    localStorage.setItem("session_start_time", new Date().getTime());




    Mixpanel.track("Session Start", {
      login_time: new Date().toISOString(), // Optional: track the login timestamp
    });
    Mixpanel.people.set({
      $name: response.data.name,
      $email: response.data.email,
      email: response.data.email,
      name: response.data.name,
    });




    const domain = getSubdomain();
    const currentPath = location.pathname;
  
    // Check if current path is a valid route using route configuration
    // Only navigate if user is on root path or invalid route
    const isValid = isValidRoute(currentPath, RouteMap);
    const isRootOrInvalidRoute = currentPath === "" || currentPath === "/" || !isValid;
  
    if (isRootOrInvalidRoute) {
      if (response.data.create_type === "OPEN_SIGNUP") {
        navigate("/integrations");
      } else if (
        domain === "bhilosa" ||
        domain === "followup" ||
        domain === "followup-stage"
      ) {
        // Existing Bhilosa logic
        if (userWorkspaceGstinStatus?.length > 0) {
          navigate(`/vendorfollowup/gstintegration`, {
            state: {
              GstinStatus: true,
              workspace: response.data.workspaces[0]?.name,
            },
          });
        } else {
          navigate(`/vendorfollowup/gstintegration`, {
            state: {
              GstinStatus: false,
              workspace: response.data.workspaces[0]?.name,
            },
          });
        }
      } else if (domain === "app") {
        navigate("/dashboard");
      } else {
        navigate("/dashboard");
      }
    }
    // if (!response.data.is_admin) {
    //   navigate("/flights");
    // }
  }
  setTimeout(() => {
    setLoading(false);
  }, 1000);
};




return isLoading ? (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
    }}
  >
    <AppLoader />
  </div>
) : (
  <div className="MasterLayout">
    <div className="NavigationContainer">
      <PrimaryNav openMenu={() => setExpandedLayout(!expandedLayout)} />
    </div>




      {/* <div
        className="PendingTaskContainer"
        style={{ display: expandedLayout ? "flex" : "none" }}
      >
        <OnboardingTasks />
      </div> */}




    <div
      className={
        "ContentLayout maxWidthLG " +
        (expandedLayout ? " " : " CollapsedLayout")
      }
    >
      <div className="AppContent">
        <Outlet />
      </div>
    </div>
    <GlobalUploader />




    {contextHolder}
  </div>
);
};




export default MasterLayout;













